import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import fetchWrapper from "../../utils/fetch/fetchWrapper";
import { BASE_URL } from '../../config';
import adaptedImageUrl from '../../config'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import DataTableExtensions from "react-data-table-component-extensions";
import 'react-data-table-component-extensions/dist/index.css';
import { Col, Form, Modal, Row } from '@themesberg/react-bootstrap';
import { LOCAL_STORAGE } from "../../context/LocalStorage";
import ModalForm from "./ModalForm";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

export default function ProfitsPercentage() {
    const [data, setData] = useState([]);
    const MySwal = withReactContent(Swal)
    const [showModal, setShowModal] = useState(false);
    const [idRowSelected, setIdRowSelected] = useState(null);
    const [imageSelected, setImageSelected] = useState(null);
    const [lightboxImage, setLightboxImage] = useState(false)


    let token = localStorage.getItem(LOCAL_STORAGE.AUTH_TOKEN)
    const fetchData = (event) => {
        fetchWrapper()
          .doGet({
              url: "/profits_percentage",
              onSuccess: async (response) => {
                  setData(response.data.profitsPercentage)
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
        // axios({
        //     method: "get",
        //     url: BASE_URL + "/profits_percentage",
        //     headers: {
        //         'Authorization': token
        //     },
        //     timeout: 1000
        // })
        //     .then(function (response) {
        //         console.log(response.data);
        //         if ((response.data.status = 200)) {
        //             setData(response.data.profitsPercentage)
        //         }
        //     })

        //     .catch(function (error) {
        //         console.log(error);
        //     });
    }

    useEffect(() => {
        fetchData()
    }, []);

    const handleActiveCheckboxChange = (event) => {
        let checkboxValue = event.target.value

        MySwal.fire({
            title: <p>¿Está seguro de cambiarle el estado a esta fila?</p>,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar',
            onOpen: () => {

            }
        }).then(() => {
            fetchWrapper()
          .doPost({
              url: "/active_desactive_distance_price",
              body:{
                  distance_id: Number(checkboxValue)
              },
              onSuccess: async (response) => {
                fetchData()
                Swal.fire(
                    'Confirmado!',
                    'Se ha cambiado el estado.',
                    'success'
                )
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
            // axios({
            //     method: "post",
            //     url: BASE_URL + "/active_desactive_distance_price",
            //     headers: {
            //         'Authorization': token
            //     },
            //     data: {
            //         distance_id: Number(checkboxValue),

            //     },
            //     timeout: 5000,
            // })
            //     .then(
            //         function (response) {
            //             if (response.data.status == 200) {
            //                 fetchData()
            //                 Swal.fire(
            //                     'Confirmado!',
            //                     'Se ha cambiado el estado.',
            //                     'success'
            //                 )
            //             }
            //         }.bind(this)
            //     )
            //     .catch(function (error) {
            //         if (error.response) {
            //             console.log(error.message);
            //             // console.log(response.data.message);
            //             alert(response.data.message);
            //         } else if (error.request) {
            //             alert("Error de conexion");
            //         } else {
            //             // console.log(error.message);
            //             alert(error.message);
            //         }
            //     });

        })
    }

    const editModal = (id) => {
        setIdRowSelected(id)
        setShowModal(true)

    }

    const columns = [
        {
            name: "Tipo",
            selector: "type",
            sortable: true,
        },
        {
            name: "Porcentaje de ganancia",
            selector: "profits_percentage",
            sortable: true,
        },
        // {
        //     name: 'Activar/Desactivar Usuario',
        //     cell: row => <label className="form-check form-switch"> <input className="form-check-input" value={row.id} checked={row.active == 1 ? true : false} type="checkbox" onChange={handleActiveCheckboxChange} /><span className="slider round"> </span></label>,
        // },
        {
            name: 'Acciones',
            cell: row => <a onClick={() => editModal(row.id)}><i className="fas fa-edit"></i></a>,
        },
    ];

    const tableData = {
        columns,
        data
    };

    return (
        <>

            <ModalForm
                showModal={showModal}
                setShowModal={setShowModal}
                id={idRowSelected}
                setId={setIdRowSelected}
                fetchData={fetchData}
            />

            {lightboxImage && (
                <Lightbox
                    mainSrc={imageSelected}
                    onCloseRequest={() => setLightboxImage(false)}
                />
            )}

            <div className="row mt-5 mb-5">
                <div className="col-md-10">
                    <h3>Administración de porcentajes de ganancia</h3>
                </div>
                {/* <div className="col-md-2">
                    <button style={{ float: "right", marginRight: "20px" }} className="btn btn-primary mr-3"
                        onClick={() => setShowModal(true)}> Nuevo
                    </button>
                </div> */}
            </div>

            <DataTableExtensions {...tableData}>
                <DataTable
                    columns={columns}
                    data={data}
                    pagination
                    noHeader
                    paginationPerPage={10}
                />
            </DataTableExtensions>
        </>
    );
}
